// SearchQueriesChart.js
import React from "react";
import { Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
} from "chart.js";


ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const SearchQueriesChart = () => {
    const labels = [
        "Query 1",
        "Query 2",
        "Query 3",
        "Query 4",
        "Query 5",
        "Query 6",
        "Query 7",
    ];

    const values = [75, 65, 55, 45, 35, 25, 15]; // Same value for demo
    const colors = [
        "#502B7C",
        "#6E42A6",
        "#839CDB",
        "#ABC0E2",
        "#C175AA",
        "#D789BD",
        "#EAA2D0",
    ];

    const data = {
        labels,
        datasets: [
            {
                label: "Search Queries",
                data: values,
                backgroundColor: colors,
                borderRadius: 5,
                barThickness: 20,
                categoryPercentage: 1.0,  // <- Fill entire vertical category space
                barPercentage: 1.0,       // <- Remove spacing inside the category
            },
        ],
    };

    const options = {
        indexAxis: "y", // Makes bars horizontal
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { display: false },
            tooltip: {
                enabled: true, // ❌ Turn off tooltip if you also don't want hover values
            },
            datalabels: {
                display: false, // ⛔ Explicitly disable data labels if plugin is registered
            },
            tooltip: {
                callbacks: {
                    label: (context) => `${context.parsed.x}%`,
                },
            },
        },
        scales: {
            x: {
                min: 0,
                max: 100,
                ticks: {
                    stepSize: 10,
                    callback: (val) => `${val}%`,
                },
                grid: {
                    display: false,
                },
            },
            y: {
                ticks: {
                    font: { size: 14 },
                },
                grid: {
                    display: false,
                },
            },
        },
    };

    return (
        <div className="queries-chart-container">
            <div className="chart-wrapper">
                <Bar data={data} options={options} />
            </div>
        </div>
    );
};

export default SearchQueriesChart;
